// ============================================================================
// Barra de progresso EMPILHADA + legenda — capítulo novo do DS (nascido na
// refatoração visual de Transferências, 2026-09-10).
//
// Uso canônico (detalhe da ordem de transferência): parcelas que somam um
// total — conferido (verde) + falta contada (vermelho) + em trânsito (azul) —
// sobre um trilho cinza que representa o que resta (a expedir). O segmento
// "Falta" (e a entrada dele na legenda) só é renderizado quando há perda.
//
// As cores de segmento são semântica de DADO (efeito no estoque), não de ação
// (G.1) — o azul do "em trânsito" coincide com o token actionWrite por herança
// da paleta, não por significar escrita.
// ============================================================================
import styled from 'styled-components';

const SEGMENT_COLOR = {
   received: '#2e7d32', // conferido / entrou no destino
   missing: '#dc2626', // falta contada na conferência
   transit: '#4098ef', // expedido, ainda em trânsito
};

export const ProgressTrack = styled.div`
   display: flex;
   height: 8px;
   border-radius: 999px;
   overflow: hidden;
   background: #dcdcdf; /* trilho = parcela ainda não expedida */
`;

// $pct: largura percentual (0–100). $tone: 'received' | 'missing' | 'transit'.
export const ProgressSegment = styled.span`
   display: block;
   width: ${({ $pct }) => `${$pct}%`};
   background: ${({ $tone }) => SEGMENT_COLOR[$tone] ?? '#dcdcdf'};
`;

export const ProgressLegend = styled.div`
   display: flex;
   align-items: center;
   gap: 12px;
   flex-wrap: wrap;
   font-size: 11px;
   color: ${({ theme }) => theme.colors.textMuted};
`;

export const LegendItem = styled.span`
   display: inline-flex;
   align-items: center;
   gap: 5px;
   white-space: nowrap;
`;

// Quadradinho da legenda. $tone: mesmo domínio do segmento + 'track' (trilho).
export const LegendSwatch = styled.span`
   width: 8px;
   height: 8px;
   border-radius: 2px;
   background: ${({ $tone }) =>
      $tone === 'track' ? '#dcdcdf' : SEGMENT_COLOR[$tone] ?? '#dcdcdf'};
`;
